<template>
  <div class="search-bar" :class="{ 'expanded': searchOpen }">
    <div class="search-icon" @click="searchProducts">
      <i class="material-icons">search</i>
    </div>
    <transition name="fade">
      <div class="search-input" v-if="searchOpen">
        <input type="text" placeholder="Cerca..." @input="searchProducts" v-model="searchQuery"/>
        <div class="search-button" @click="toggleSearch">
          <span>annulla</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchOpen: false,
      searchQuery: '',
    };
  },
  methods: {
    toggleSearch() {
      this.searchOpen = !this.searchOpen;
      this.searchQuery = '';
      this.$emit('search', this.searchQuery)
      this.$emit('search-status', this.searchOpen)
    },
    searchProducts() {
      if (this.searchOpen) {
        this.$emit('search', this.searchQuery);
      } else {
        this.toggleSearch();
      }
    }
  }
};
</script>

<style scoped>
.search-bar {
  display: flex;
  align-items: center;
  background-color: var(--header-color);
  height: 100%;
}

.search-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center; 
  margin-right: 10px;
  padding-right: 10px;
  padding-left: 10px;
}

.search-icon i {
  color: var(--text-color);
  font-size: 30px;
}

.search-input {
  display: flex;
  align-items: center;
  width: 80vw;
}

.search-input input {
  padding: 5px;
  border: none;
  border-radius: 18px;
  background-color: var(--secondary-color);
  border-bottom: 1px solid var(--border-color); 
  color: var(--text-color); 
  width: 80%;
  height: 35px;
}

.search-button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.search-button span {
  color: var(--text-color);
  font-size: 16px;
}

div.search-bar.expanded {
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--header-color);
  width: 100vw;
  z-index: 1100;
}
</style>
